var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section-hero',{attrs:{"bgImg":_vm.bgImg,"subtitle":_vm.subtitle}}),_vm._v(" "),(_vm.mainArticle.id)?_c('section-article',{attrs:{"id":"scrollToOnLoad","article":_vm.mainArticle}}):_vm._e(),_vm._v(" "),_c('section-figures',{attrs:{"figures":_vm.allArticles,"btnText":"Resources","itemColSize":"4"}}),_vm._v(" "),_c('section-support')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7efaef2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NeedToKnow.vue
// module id = null
// module chunks = 